// Небольшая обёртка над BX24 в промис-стиле + утилиты

export function bxCallMethod<T = any>(method: string, params?: any): Promise<T> {
  return new Promise((resolve, reject) => {
    BX24.callMethod(method, params || {}, (res: any) => {
      const err = res?.error?.();
      if (err) return reject(err);
      const data = res?.data?.();
      resolve(data as T);
    });
  });
}

// Config methods

export async function bxSaveOfflineToken(offlineToken: string) {
  await bxCallMethod('app.option.set', {
    "options": {
      "FZ_OFFLINE_TOKEN": offlineToken
    }
  });
}

export async function bxLoadOfflineToken(): Promise<string | null> {
  const offlineToken = await bxCallMethod('app.option.get', {
    "option": "FZ_OFFLINE_TOKEN"
  });
  return offlineToken;
}

export async function bxClearOfflineToken() {
  await bxSaveOfflineToken('');
}


// Deal methods

async function bxGetCurrentDealId(): Promise<string> {
  const info = BX24.placement.info();
  if (info?.placement !== 'CRM_DEAL_DETAIL_TAB') {
    throw new Error('ID сделки доступен только на карточке сделки');
  }

  const dealId = info.options?.ID;
  if (!dealId) {
    throw new Error('Не удалось определить ID сделки');
  }
  return dealId;
}

export async function bxSaveOrderIdForCurrentDeal(orderId: string): Promise<void> {
  if (!orderId) {
    throw new Error('orderId is empty');
  }

  const dealId = await bxGetCurrentDealId();
  const result = await bxCallMethod<boolean>('crm.deal.update', {
    id: dealId,
    fields: {
      UF_CRM_FZ_ORDER_ID: orderId
    }
  });
  if (result !== true) {
    throw new Error('Failed to save orderId');
  }
}

export async function bxGetOrderIdForCurrentDeal(): Promise<string | null> {
  const dealId = await bxGetCurrentDealId();
  const item = await bxCallMethod<any>('crm.deal.get', {
    id: dealId
  });
  return item?.UF_CRM_FZ_ORDER_ID;
}

export async function bxGetInnForCurrentDeal(): Promise<string | null> {
  const info = BX24.placement.info();
  if (info?.placement !== 'CRM_DEAL_DETAIL_TAB') {
    throw new Error('ID сделки доступен только на карточке сделки');
  }

  const result = await bxCallMethod<any>('crm.deal.get', {
    id: info.options?.ID
  });

  const companyId = result?.COMPANY_ID;
  if (!companyId) {
    return null;
  }
  const items = await bxCallMethod<any[]>('crm.requisite.list', {
    select: ["ENTITY_ID", "RQ_INN"],
    filter: { ENTITY_TYPE_ID: 4, ENTITY_ID: companyId }
  });

  if (!Array.isArray(items) || items.length !== 1) return null;
  const item = items[0];
  const inn = item.RQ_INN;
  return inn;
}

// Company methods

async function bxGetCurrentCompanyId(): Promise<string> {
  const info = BX24.placement.info();
  console.log("bxGetCurrentCompanyId", info);
  if (info?.placement !== 'CRM_COMPANY_DETAIL_TAB') {
    throw new Error('ID компании доступен только на карточке компании');
  }

  const dealId = info.options?.ID;
  if (!dealId) {
    throw new Error('Не удалось определить ID компании');
  }
  return dealId;
}

export async function bxGetInnForCurrentCompany(): Promise<string | null> {
  const companyId = await bxGetCurrentCompanyId();

  const items = await bxCallMethod<any[]>('crm.requisite.list', {
    select: ["ENTITY_ID", "RQ_INN"],
    filter: { ENTITY_TYPE_ID: 4, ENTITY_ID: companyId }
  });

  if (!Array.isArray(items) || items.length !== 1) return null;
  const item = items[0];
  const inn = item.RQ_INN;
  return inn;
}

export function bxOpenSlider(action: string, data: any): void {
  BX24.openApplication({ action, data });
}

// Auth

export function bxGetCurrentMemberId(): string | undefined {
  return BX24.getAuth()?.member_id;
}
